"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserRegistryStatusEndpoint = getUserRegistryStatusEndpoint;
function getUserRegistryStatusEndpoint() {
    return "/user-registry-status";
}
//# sourceMappingURL=user-registry.js.map